import React from 'react'

export default function PrivacyPolicy() {

    // on hash click
    const handleHashUrlClick = (ev, hash) => {
        ev.preventDefault()
        if (hash) {
            const elem = document.getElementById(hash)

            // scrolling to element
            if (elem) {
                window.scrollTo(0, elem.offsetTop)
            }
        }
    }
    return (
        <div className="page-split-view">
            <div className="inner">
                {/* text */}
                <div className="text-sec">
                    <div className="frac mb-3" id="ppt1">
                        <p className="head st-fw-600 st-fs-15 text-decoration-underline mb-2">At KraveGlassUSA.com we value your need for privacy.</p>
                        <ul className="ps-3">
                            <li className="st-fs-15">
                                We do not sell your personal information collected during checkout
                            </li>
                            <li className="st-fs-15">
                                We may use your phone number and / or e-mail to contact you in case of questions regarding your order.
                            </li>
                            <li className="st-fs-15">
                                All transactions made on our website show a charge from 'Hi Life Tobacco Inc.' on your credit card / bank statement.
                            </li>
                            <li className="st-fs-15">
                                All packages are shipped in discreet packaging.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}
